import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {User} from "./user";

@Injectable({
    providedIn: 'root'
})
export class UserStateService {

    private userSubject = new BehaviorSubject<User | null>(null);
    private userCallReady$ = new BehaviorSubject<boolean>(false);

    constructor() {
    }
    set userCallReady(done: boolean) {
        this.userCallReady$.next(done);
    }
    get userCallReady(): Observable<boolean> {
        return this.userCallReady$.asObservable();
    }

    set user(user: User | null ) {
        this.userSubject.next(user);
    }

    get user$(): Observable<User  | null> {
        return this.userSubject.asObservable();
    }

    get user(): User  | null {
        return this.userSubject.value;
    }

}
